import {FC} from 'react'
import {useFormContext, useFormState} from 'react-hook-form'
import {Body, BodyErrors, BodyItems, Header, Row} from 'components/SearchForm/AdditionalSearchField'
import {SearchTextBox} from 'components/SearchForm/SearchTextBox'
import {Schema} from '../schema'

export const FormerName: FC = () => {
  const {register, control} = useFormContext<Schema>()
  const {errors} = useFormState({control, name: 'formerName'})

  return (
    <Row>
      <Header>旧姓</Header>
      <Body>
        <BodyItems>
          <SearchTextBox {...register('formerName', {shouldUnregister: true})} style={{width: 200}} />
        </BodyItems>
        <BodyErrors>{errors.formerName && <p>{errors.formerName.message}</p>}</BodyErrors>
      </Body>
    </Row>
  )
}
